// @flow
import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import Widget from 'app/components/Widget';
import BulletList from 'app/components/BulletList';
import styles from './WidgetReview.styles';
import api from 'utils/API';
  
class WidgetReview extends React.Component<Props> {
  unmounted = false;
  
  constructor(props) {
    super(props);

    this.state = {
      list: []
    };
  }

  componentDidMount() {
    api.post('/category/%D9%86%D9%82%D8%AF', {
      id: 'نقد',
      page: 1,
      count: 5
    })
    .then(response => {
      if (this.unmounted) {
        return;
      }
      const list = response.data.list || [];
      this.setState({list});
    });
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  render() {
    // const {classes} = this.props;
    return (
      <Widget gray title='نقد'>
        <BulletList list={this.state.list} />
      </Widget>
    );
  }
}

const Component = withStyles(styles)(WidgetReview);
export {Component as WidgetReview}